const jokesData = [
	{
		id: 1,
		question: "What is your Hobby?",
		answer: "Cricket"
	},
	{
		id: 2,
		question: "What is your Network?",
		answer: "Airtel"
	},
	{
		id: 3,
		question: "What is your City?",
		answer: "Meerut"
	},
	{
		id: 4,
		question: "What is your Address?",
		answer: ""
	},
	{
		id: 5,
		question: "What is your State?",
		answer: "Uttar Pradesh"
	}
]

export default jokesData;
